"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderCaps = exports.A = exports.ParaSmall = exports.ParaBig = exports.SubTextSmall = exports.SubTextSelected = exports.SubText = exports.ButtonText = exports.BodyText = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var styles = _interopRequireWildcard(require("./Text.style"));

var H1 = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("h1", {
    className: "".concat(className, " ").concat(styles.h1(otherProps))
  }, children);
});
exports.H1 = H1;
var H2 = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("h2", {
    className: "".concat(className, " ").concat(styles.h2(otherProps))
  }, children);
});
exports.H2 = H2;
var H3 = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className3 = props.className,
      className = _props$className3 === void 0 ? '' : _props$className3,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("h3", {
    className: "".concat(className, " ").concat(styles.h3(otherProps))
  }, children);
});
exports.H3 = H3;
var H4 = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className4 = props.className,
      className = _props$className4 === void 0 ? '' : _props$className4,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("h4", {
    className: "".concat(className, " ").concat(styles.h4(otherProps))
  }, children);
});
exports.H4 = H4;
var H5 = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className5 = props.className,
      className = _props$className5 === void 0 ? '' : _props$className5,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("h5", {
    className: "".concat(className, " ").concat(styles.h5(otherProps))
  }, children);
});
exports.H5 = H5;
var BodyText = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className6 = props.className,
      className = _props$className6 === void 0 ? '' : _props$className6,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.bodyText(otherProps))
  }, children);
});
exports.BodyText = BodyText;
var ButtonText = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className7 = props.className,
      className = _props$className7 === void 0 ? '' : _props$className7,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.buttonText(otherProps))
  }, children);
});
exports.ButtonText = ButtonText;
var SubText = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className8 = props.className,
      className = _props$className8 === void 0 ? '' : _props$className8,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.subText(otherProps))
  }, children);
});
exports.SubText = SubText;
var SubTextSelected = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className9 = props.className,
      className = _props$className9 === void 0 ? '' : _props$className9,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.subTextSelected(otherProps))
  }, children);
});
exports.SubTextSelected = SubTextSelected;
var SubTextSmall = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className10 = props.className,
      className = _props$className10 === void 0 ? '' : _props$className10,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.subTextSmall(otherProps))
  }, children);
});
exports.SubTextSmall = SubTextSmall;
var ParaBig = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className11 = props.className,
      className = _props$className11 === void 0 ? '' : _props$className11,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.paraBig(otherProps))
  }, children);
});
exports.ParaBig = ParaBig;
var ParaSmall = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className12 = props.className,
      className = _props$className12 === void 0 ? '' : _props$className12,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.paraSmall(otherProps))
  }, children);
});
exports.ParaSmall = ParaSmall;
var A = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className13 = props.className,
      className = _props$className13 === void 0 ? '' : _props$className13,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("a", {
    className: "".concat(className, " ").concat(styles.a(otherProps))
  }, children) // eslint-disable-line jsx-a11y/anchor-is-valid
  ;
});
exports.A = A;
var HeaderCaps = (0, _emotionTheming.withTheme)(function (props) {
  var _props$className14 = props.className,
      className = _props$className14 === void 0 ? '' : _props$className14,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
  return _react.default.createElement("div", {
    className: "".concat(className, " ").concat(styles.headerCaps(otherProps))
  }, children);
});
exports.HeaderCaps = HeaderCaps;